export default "__VITE_ASSET__a86f9186__"